import EditFieldModal from "@/modules/common/components/modals/edit-field-modal";
import { Typography } from "@mui/material";

export default function MissingDataModal({
  open,
  handleOpen,
  handleClose,
  handleConfirm,
}: {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  handleConfirm?: () => void;
}) {

  const handleModalOpen = () => {
    handleOpen();
  };

  const handleModalClose = () => {
    handleClose();
  };

  const handleModalConfirm = () => {
    handleModalClose();
    handleConfirm?.();
  };
  return (
    <>
      <EditFieldModal
        open={open}
        setOpen={handleModalOpen}
        header="Missing data"
        width={480}
        handleConfirm={handleModalConfirm}
        handleCloseModal={handleModalClose}
        confirmText="Fill in missing data"
      >
        <Typography
          sx={(t) => t.nawy.typography.english.variants.body.md.regular}
        >
          Some data is missing from listing details, please fill them in before
          publishing.
        </Typography>
      </EditFieldModal>
    </>
  );
}
